import React, { useEffect, useState } from 'react'
import { CodeSnippet } from '../components/code-snippet'
import { PageLayout } from '../components/page-layout'
import { getMeasurementResource } from '../services/message.service'

export const MeasurementPage: React.FC = () => {
  const [message, setMessage] = useState<string>('')

  useEffect(() => {
    let isMounted = true;

    const getMessage = async () => {
     
      const { data, error } = await getMeasurementResource();
      console.log('data, error = ', data, error)

      if (!isMounted) {
        return
      }

      if (data) {
        setMessage(JSON.stringify(data, null, 2))
      }

      if (error) {
        setMessage(JSON.stringify(error, null, 2))
      }
    }

    getMessage()

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <PageLayout>
      <div className="content-layout">
        <h1 id="page-title" className="content__title">
          Measurement Page
        </h1>
        <div className="content__body">
          <p id="page-description">
            <span>
              This page retrieves an <strong>measurement message</strong> from an AWS API.
            </span>
            <span>
              <strong>
                Only authenticated users with the <code>read:admin-messages</code> permission should access this page.
              </strong>
            </span>
          </p>
          <CodeSnippet title="Measurement Message" code={message} />
        </div>
      </div>
    </PageLayout>
  )
}
